import React from 'react';
import styled from 'styled-components';
import AddIcon from '@material-ui/icons/Add';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { sidebarItems } from '../Data/SidebarData';
import db from '../firebase';

import { useHistory } from "react-router-dom";

function Sidebar(props) {
    
    const history =useHistory();
    //Functions
    const goTochannel =(id) =>{

        if(id){
            console.log(id+" clicked");
            history.push(`/room/`+id);
        }
    }
    const addChannel =() =>{ 
        const promptName =prompt("Enter Name of the Channel You wish to Create");
        // console.log(promptName);

        if(promptName){
            db.collection('rooms').add({
                name: promptName
            })
        }
    }
    
    
    
    
    
    //function ends

    //DOM
    return (
        <Container className="Sidebar">
            <WorkSpaceContainer>
                <Name>Prem</Name>
                <NewMessage><AddCircleOutlineIcon/></NewMessage>
            </WorkSpaceContainer>
            <MainChannels>
                {
                    sidebarItems.map(item => (
                        <MainChannelItems>
                            {item.icon}
                            {item.text}
                        </MainChannelItems>

                    ))
                }
            </MainChannels>

            <ChannelContainer>
                <NewChannelContainer>
                    <div>
                        Channels
                    </div>
                    <AddIcon Class_name="click" onClick={addChannel}/>
                </NewChannelContainer>

                <ChannelsList>
                    {
                    props.rooms.map(item=>(

                    <Channel onClick={()=>goTochannel(item.id)}>
                        # {item.name}
                    </Channel>

                    ))
                    }
                </ChannelsList>
            </ChannelContainer>
        </Container>
    )
}
//DOM


export default Sidebar
//CSS
const Container = styled.div`
background-color:#3F0E40;
color:#FFFFFF;
`
const WorkSpaceContainer = styled.div`
color:white;
height:64px;
align-items:center;
display:flex;
padding: 0 12px;
justify-content:space-between;
border-bottom: 1px solid #532753;

`

const Name = styled.div` 

`

const NewMessage = styled.div`
width:36px;
height:36px;
background-color:white;
color:white;
border-radius: 50%;
color: #3F0E40;
fill: #3F0E40;
display:flex;
justify-content: center;
align-items: center;
margin-right:5px;
cursor:pointer;
`
const MainChannels = styled.div`
padding-top: 20px;


`

const MainChannelItems = styled.div`
    color: rgb(188,171,188);
    display:grid;
    grid-template-columns:15% auto;
    height:28px;
    align-items: center;
    padding-left:19px;
    cursor:pointer;
    :hover{
        background: #350D36;
    }
`
const ChannelContainer = styled.div`
margin-top: 20px;

color: rgb(188,171,188);





`
const NewChannelContainer = styled.div`

display:flex;
justify-content: space-between;
align_items:center;
height:28px;
padding-left:19px;
padding-right:12px;
`
const ChannelsList = styled.div`
height:420px;
overflow:scroll;
-ms-overflow-style: none;  /* IE and Edge */
scrollbar-width: none;  /* Firefox */

::-webkit-scrollbar {
    display: none;
  }
  
 
scrollbar-color: red yellow;
  

    

`
const Channel = styled.div`
height:28px;
display:flex;
align_items:center;
padding-left:20px;
cursor:pointer;

:hover{
    background: #350D36;
}
`